// src/sections/AccompanimentsAndStarters/AccompanimentsAndStarters.js
import React from 'react';
import styles from './AccompanimentsAndStarters.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

// CORRIGÉ : Ordre des éléments ajusté pour correspondre à la liste du menu
const startersData = [
  { id: "starter-nems-poulet", name: "NEMS POULET (4 PCS)", price: "4.90€", description: "" },
  { id: "starter-nems-crevette", name: "NEMS CREVETTES (4 PCS)", price: "4.90€", description: "" },
  { id: "starter-jalapenos", name: "JALAPENOS (4 PCS)", price: "4.90€", description: "" },
  { id: "starter-brochettes-teriyaki", name: "BROCHETTES POULET TERIYAKI (4 PCS)", price: "4.90€", description: "" },
  { id: "starter-brochettes-ananas", name: "BROCHETTES POULET ANANAS (4 PCS)", price: "4.90€", description: "" },
  { id: "starter-samoussas", name: "SAMOUSSAS (4 PCS)", price: "4.90€", description: "" },
  { id: "starter-panko", name: "CREVETTES PANKO (6 PCS)", price: "5.50€", description: "" },
];

// CORRIGÉ : Ordre des éléments ajusté et détails de texte harmonisés
const tastingPlattersData = [
  { id: "platter-rice", name: "PORTION DE RIZ PARFUMÉ", price: "3.00€", description: "" },
  { id: "platter-wakame", name: "SALADE DE WAKAMÉ", price: "5.00€", description: "" },
  { 
    id: "platter-1-person", 
    name: "PLATEAU DÉGUSTATION (1 PERSONNE, 7 PCS)", 
    price: "10.00€", 
    // CORRIGÉ : "jalapenos" sans accent pour correspondre à la liste
    description: "Contenu : 1 portion de riz parfumé, nems poulet x1, nems crevettes x1, jalapenos x1, crevettes panko x1, brochettes poulet ananas x1, brochettes poulet teriyaki x1, samoussas x1." 
  },
];

const AccompanimentsAndStarters = ({ id, favorites, addFavorite, removeFavorite }) => {

  const isFavorite = (item) => {
    return favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.accompanimentsAndStarters}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>ACCOMPAGNEMENTS & ENTRÉES</h2>

        <div className={styles.contentWrapper}>
          {/* Colonne 1: Starters */}
          <div className={styles.column}>
            {startersData.map((item) => (
              <div key={item.id} className={styles.menuItem}>
                <div className={styles.itemContentLine}>
                  <span className={styles.itemName}>{item.name}</span>
                  <span className={styles.itemSeparator}></span>
                  
                  <div className={styles.priceAndFavorite}>
                    <span className={styles.itemPrice}>{item.price}</span>
                    <button
                      className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                      onClick={() => handleFavoriteClick(item)}
                      aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                    >
                      <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                    </button>
                  </div>
                </div>
                {item.description && (
                  <p className={styles.itemDescription}>{item.description}</p>
                )}
              </div>
            ))}
          </div>

          {/* Colonne 2: Tasting Platters */}
          <div className={styles.column}>
            {tastingPlattersData.map((item) => (
              <div key={item.id} className={styles.menuItem}>
                <div className={styles.itemContentLine}>
                  <span className={styles.itemName}>{item.name}</span>
                  <span className={styles.itemSeparator}></span>
                  
                  <div className={styles.priceAndFavorite}>
                    <span className={styles.itemPrice}>{item.price}</span>
                    <button
                      className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                      onClick={() => handleFavoriteClick(item)}
                      aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                    >
                      <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                    </button>
                  </div>
                </div>
                {item.description && (
                  <p className={styles.itemDescription}>{item.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccompanimentsAndStarters;